import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-minus\">\n<path d=\"M16.7,100c0-6.9,5.6-12.5,12.5-12.5l0,0h141.7c6.9,0,12.5,5.6,12.5,12.5c0,6.9-5.6,12.5-12.5,12.5H29.2\n\tC22.3,112.5,16.7,106.9,16.7,100z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol